export type Suggestion = {
	street_line: string;
	secondary: string;
	city: string;
	state: string;
	zipcode: string;
	entries: number;
};

// variation of function from https://www.smarty.com/docs/cloud/us-autocomplete-pro-api
export function buildAddress(suggestion: Suggestion, selected = false) {
	let whiteSpace = '';
	if (suggestion.secondary) {
		if (suggestion.entries > 1) {
			suggestion.secondary += ' (' + suggestion.entries + `${selected ? ')' : ' entries)'}`;
		}
		whiteSpace = ' ';
	}
	return (
		suggestion.street_line +
		whiteSpace +
		suggestion.secondary +
		' ' +
		suggestion.city +
		`${selected ? ' ' : ', '}` +
		suggestion.state +
		' ' +
		suggestion.zipcode
	);
}
